import React from 'react'
import { connect } from "react-redux";
import { PostMemberCancelDeposit, SetDepositSuccessPage } from '$Deposits/store/actions/DepositAction'



class NextStep extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            showTrips: true,
        };
    }

    componentDidMount() {

    }
    componentWillUnmount() {

    }



    render() {

        const {
            MethodsActive,
            DepositPayments,
            PostMemberCancelDeposit,
            SetDepositSuccessPage,
            Modal,
            ModalWarning,
            NextStep,
        } = this.props

        const { qrDeepLink, isDummyBank = false } = DepositPayments || {}


        return (
            <>
                <Modal
                    modalVisible={this.state.showTrips && !isDummyBank}
                    title={'แจ้งเตือน'}
                    msg={'กรุณาโอนเงินเป็นจำนวนทศนิยมตามที่ระบบกำหนดเท่านั้น เพื่อความรวดเร็วในการตรวจสอบและอนุมัติยอดเงิน'}
                    onlyOkBtn={true}
                    onOk={() => { this.setState({ showTrips: false }) }}
                    okText={'ตกลง'}
                />

                <ModalWarning
                    modalVisible={isDummyBank}
                    modes={'warning'}
                    title={'การฝากเงินล้มเหลว'}
                    msg={'ขออภัยไม่มีธนาคารให้บริการในขณะนี้ รายการฝากนี้ จะถูกยกเลิก กรุณาทำรายการฝากด้วยช่องทางอื่น'}
                    cancelText={'ปิด'}
                    okText={'ทำการฝากใหม่'}
                    onCancel={() => { PostMemberCancelDeposit() }}
                    onOk={() => { PostMemberCancelDeposit() }}
                />
                <NextStep
                    MethodsActive={MethodsActive}
                    DepositPayments={DepositPayments}
                    backClick={() => {SetDepositSuccessPage()}}
                    onChange={() => { SetDepositSuccessPage(true) }}
                />
            </>
        );
    }
}

const mapStateToProps = state => ({
    MethodsActive: state.MethodsActive,
    DepositPayments: state.DepositPayments,
});
const mapDispatchToProps = {
    PostMemberCancelDeposit: (data) => PostMemberCancelDeposit(data),
    SetDepositSuccessPage: (data = false) => SetDepositSuccessPage(data),
};
export default connect(mapStateToProps, mapDispatchToProps)(NextStep);


